import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import UserTypes from "components/auth/user-types";
import ServiceReassignmentWidget from "components/menu/dashboard/service-reassignment-widget";
import ServicesWidget from "components/menu/dashboard/services-widget";
import MerchandiserDashboard from "components/menu/dashboard/merchandiser/merchandiser-dashboard";

class Dashboard extends React.Component {
    render () {
        const {
            auth
        } = this.props;

        const showServiceReassignmentWidget =
            auth.user.role.includes(UserTypes.admin) ||
            auth.user.role.includes(UserTypes.accountManager) ||
            auth.user.role.includes(UserTypes.supervisor);

        const showMerchandiserDashboard = auth.user.role.includes(UserTypes.merchandiser);

        return (
            <div className="dashboard">
                {showMerchandiserDashboard ?
                    <MerchandiserDashboard />
                : (
                    <div className="row">
                        <div className="col-12">
                            <ServicesWidget />
                        </div>
                        <div className="col-12 mt-4">
                            {!showServiceReassignmentWidget || <ServiceReassignmentWidget />}
                        </div>
                    </div>

                    // <div
                    //    className="flex-column align-items-center justify-content-center d-none"
                    // >
                    //     <h4 className="mb-1 text-center">Test Chart</h4>
                    // </div>
                )}

            </div>
        );
    }
}

Dashboard.propTypes = {
    auth: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
    auth: state.auth,
});

export default connect(
    mapStateToProps,
)(Dashboard);
